import { PostType } from '@tribeplatform/gql-client/types'

import { CMSTreeItem } from '../components/CMSTreeItem.js'
import { TreeItems } from '../types.js'

export function getCMSIndex(postTypeId: string) {
  return `cms_${postTypeId}`
}

export function createCMSTreeItem({
  postType,
}: {
  postType: PostType
}): TreeItems {
  return {
    [getCMSIndex(postType.id)]: {
      index: getCMSIndex(postType.id),
      isFolder: false,
      data: {
        type: 'simple',
        title: postType.name,
        render: () => <CMSTreeItem postType={postType} />,
      },
    },
  }
}
